import type { SupportedCountry } from '@archipro-website/localisation';
import {
    getCountryHrefLang,
    isSupported,
} from '@archipro-website/localisation';

export const getSiteLang = (country: SupportedCountry): string => {
    if (!isSupported(country)) {
        throw new Error(`Unknown country provided to getSiteLang: ${country}`);
    }
    // Derived from the shared country config so new markets work automatically.
    return getCountryHrefLang(country);
};
